import { render, staticRenderFns } from "./FormElementChallenge.vue?vue&type=template&id=813454b8&scoped=true&"
import script from "./FormElementChallenge.vue?vue&type=script&lang=js&"
export * from "./FormElementChallenge.vue?vue&type=script&lang=js&"
import style0 from "./FormElementChallenge.vue?vue&type=style&index=0&id=813454b8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "813454b8",
  null
  
)

export default component.exports